<template>
  <div>
    <van-card
        @click="handleRouter">
      <template #thumb>
        <div :style="{'background-image': 'url('+getThumbUrl(cardData.thumbUrl)+')','background-size':'100%, 100%'}" class="van-image">
          <van-image :src="require('../assets/img/jing.png')" style="margin: 2%;"/>
        </div>
      </template>
      <template #tags>
        <div class="end-box">
          <div class="leftArea">
            <div >
              <van-icon :name="getIcon(cardData.taskName)" size="1rem"/>
              <span style="margin-left: 0.2rem">{{ cardData.orderNumbers }}</span>
            </div>
            <div style="margin-top: 5px;">{{cardData.taskName}}</div>
            <div style="margin-top: 10px;">{{cardData.tasktype}}</div>
            <div>{{cardData.createTime}}</div>
          </div>
          <div class="rightArea">
            <div style="color: orangered">实付金额:<span style="margin-left: 3px;">{{cardData.userPlateformMoney }}</span></div>
            <div style="color: orangered">佣金:<span style="margin-left: 3px;">{{cardData.commission}}</span></div>
            <van-button size="mini" type="info" @click="handleRouter" :disabled="cardData.statusName == '已取消'">{{ cardData.statusName }}</van-button>
            <van-button size="mini" type="danger" @click="handleAppeal">申诉</van-button>
          </div>
        </div>
      </template>
    </van-card>
    <van-divider dashed :style="{color: '#4d84e2', margin:'8px 0'}"></van-divider>
  </div>
</template>

<script>
export default {
  name: "TaskItemComponent",
  props:["cardData"],
  data() {
    return {
      icons: [
        {
          id: 1,
          icon: require("../assets/img/0.png")
        },
        {
          id: 2,
          icon: require("../assets/img/1.png")
        },
        {
          id: 3,
          icon: require("../assets/img/2.png")
        },
        {
          id: 4,
          icon: require("../assets/img/3.png")
        },
        {
          id: 5,
          icon: require("../assets/img/5.png")
        }
      ]
    }
  },
  mounted() {
    console.log(this.cardData)
  },
  computed:{
    getThumbUrl(){
      return function (url) {
        if (url !== undefined) {
          url = (url.substr(0, 5).toLowerCase() == "http:" || url.substr(0, 6).toLowerCase() == "https:") ? url : "http:" + url;
          console.log(url)
          return url;
        }
      }
    },
    getIcon(){
      return function (taskName) {
        if (taskName){
          if (taskName.includes("京东")){
            return this.icons[1].icon;
          }else if (taskName.includes("拼多多")){
            return this.icons[2].icon;
          }else if (taskName.includes("抖音")){
            return this.icons[3].icon;
          }else if (taskName.includes("阿里巴巴")){
          return this.icons[4].icon;
          }else{
            return this.icons[0].icon;
          }
        }
      }
    }
  },
  methods:{
    handleAppeal(val){
      console.log(val)
      this.$emit("goToAppealCenter", this.cardData);
    },
    handleRouter(val){
      console.log(val, this.cardData)
      this.$emit("goToDetail", this.cardData);
    }
  }
}
</script>

<style lang="scss" scoped>
.end-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  .rightArea {
    display: flex;
    flex-flow: column nowrap;
    justify-content: right;
  }

  .rightArea > *{
    margin: 4px;
  }

  .leftArea > *{
    margin: 5px;
  }
}
</style>
